import React from 'react'
import SidebarUserView from './SidebarUserView'
import {useAppSelector} from 'hooks'
import {useTranslation} from 'react-i18next'


const SidebarUser = ({
    activityCount, hasActivity,
}: {activityCount: number,
    hasActivity: boolean,}) => {
    const {
        userConnected, userIdle, userName, userIconUrl,
    } = useAppSelector(({ninchat}) => ({
        userConnected: ninchat.user_attrs.connected,
        userIconUrl: ninchat.user_attrs.iconurl,
        userIdle: ninchat.user_attrs.idle,
        userName: ninchat.user_attrs.name,
    }))

    const {t} = useTranslation()
    const label = hasActivity ? t('{{count}} notifications', {count: activityCount}) : userName

    return (
        <SidebarUserView
            hasActivity={hasActivity}
            label={label}
            userConnected={userConnected}
            userIconUrl={userIconUrl}
            userIdle={userIdle}
            userName={userName}
        />
    )
}

export default SidebarUser
